import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import {
  BRANDING_CONTEXTUAL_HELP,
  TOOLTIP_PRESSED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { ContextualHelp } from 'src/app/v1/views/shared/ContextualHelp';
import type { TrackingEvent } from 'src/types/trackingData';

import translations from './.vocab';

export const BrandingContextualHelp = () => {
  const { t } = useTranslations(translations);

  const sendTrackingEvent = () => {
    const eventData: TrackingEvent = {
      eventName: TOOLTIP_PRESSED,
      tooltipType: BRANDING_CONTEXTUAL_HELP,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <Box position="relative">
      <ContextualHelp onToggleOn={sendTrackingEvent}>
        <Stack space="medium">
          <Text weight="strong">{t('branding-help-text-title')}</Text>
          <Text>{t('branding-help-text-content')}</Text>
        </Stack>
      </ContextualHelp>
    </Box>
  );
};
